import { render } from "./EstimateIndexTable.vue?vue&type=template&id=fa259252"
import script from "./EstimateIndexTable.vue?vue&type=script&lang=js"
export * from "./EstimateIndexTable.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__